import instance from '../../axios';

export const createBooths = async (data) => {
  const response = await instance.post('booths/create', data);
  return response.data;
};

export const updateBooths = async (data) => {
  const response = await instance.post('booths/update', data);
  return response.data;
};

export const deleteBooths = async (data) => {
  const response = await instance.post('booths/delete', data);
  return response.data;
};

export const getAllBooths = async () => {
  const response = await instance.get('booths/get-all');
  return response.data;
};

export const getBoothsById = async (id) => {
  const response = await instance.get(`booths/get-by-id?id=${id}`);
  return response.data;
};

export const getBoothsByMerchantId = async () => {
  const response = await instance.get(`booths/get-by-merchant-id`);
  return response.data;
};

export const getBoothsForBranch = async () => {
  const response = await instance.get(`booths/get-for-branch`);
  return response.data;
};

export const getBranchById = async (id) => {
  const response = await instance.get(`booths/get-branch-by-id?id=${id}`);
  return response.data;
};
